<template>
    <transition :name="attributes.noTransition ? '' : 'fade'">
        <v-flex :id="attributes.mezo" :class="getClass" v-if="isVisible()">
            <BnHelpField
                :no-padding="attributes.noHelpPadding"
                :name="attributes.mezo"
                :active="!!attributes.help"
                :prefix="typeof attributes.forgalmiBetukod !== 'undefined'"
                :width-correction="
                    (attributes.width === 'md12 xs12' || cfg.props.oneColumn)
                     || attributes.widthCorrection
                "
                :no-end-spacing="attributes.noEndSpacing"
                :input-type="attributes.type"
            >
                <template v-if="$slots.help" #help>
                    <slot name="help" />
                </template>
                <template #one>
                    <BnForgalmiBetukod
                        :betukod="attributes.forgalmiBetukod"
                        class="mb-2"
                    />
                </template>
                <span
                    v-if="getInputType === 'span'"
                    slot="two"
                    :class="attributes.labelClass"
                >
                    {{ attributes.label }}
                </span>
                <v-layout
                    slot="two"
                    class="input-wrapper"
                >
                    <v-flex v-if="attributes.separateLabel" xs12 md6>
                        <span class="separate-label text--primary">
                            {{ attributes.label }}
                        </span>
                    </v-flex>
                    <v-flex xs12 :md6="attributes.separateLabel">
                        <component
                            v-if="typeof attributes.innerIconClick !== 'function'"
                            :color="attributes.color ? attributes.color : 'secondaryButtonColor'"
                            slot="two" @focus="focus()"
                            :label="this.hideLabel ? '' :attributes.label"
                            :is="getInputType"
                            :items="getOptions"
                            :item-text="attributes.itemsText"
                            :item-value="attributes.itemsValue"
                            :item-color="attributes.itemColor"
                            :disabled="!isEditable()"
                            v-model="inputVal"
                            :hint="getPersistentHint"
                            @keyup="onKeyUp()"
                            :rules="attributes.rules"
                            persistent-hint
                            v-bnmask="attributes.mask"
                            :clearable="getClearable"
                            :counter="attributes.counter"
                            :path="attributes.path"
                            :min="attributes.min"
                            :max="attributes.max"
                            :default-date="attributes.defaultDate"
                            :date-hint="attributes.dateHint"
                            @blur="blurFn()"
                            @change="changeFn($event)"
                            :prefix="attributes.prefix"
                            :ref="attributes.mezo"
                            :id="attributes.mezo + '-input'"
                            :error="attributes.error ? attributes.error : false"
                            :error-messages="attributes.errorMessages ? attributes.errorMessages : ''"
                            :attributes="attributes"
                            :afterDatePath="attributes.afterDatePath"
                            :beforeDatePath="attributes.beforeDatePath"
                            :append-icon="attributes.innerIcon"
                            @click:clear="clearFn"
                            @keydown="keyDownFn($event)"
                            @keypress="keyDownFn($event)"
                            :outlined="cfg.props.outlined"
                            :placeholder="attributes.placeholder "
                            :persistent-placeholder="true"
                            :multiple="attributes.multiple"
                            auto-select-first
                            :true-value="attributes.trueValue"
                            :false-value="attributes.falseValue"
                        >
                            <template
                                v-if="attributes.type === 'checkbox'"
                                #label
                            >
                                <span
                                    :class="attributes.labelClass"
                                    :style="labelStyles"
                                >
                                    {{ attributes.label }}
                                </span>
                            </template>
                            <template v-if="attributes.suffix" #append>
                                <span class="suffix" v-html="attributes.suffix" />
                            </template>
                        </component>
                        <component
                            v-else
                            :color="attributes.color ? attributes.color : 'secondaryButtonColor'"
                            slot="two"
                            @focus="focus()"
                            :label="this.hideLabel ? '' : attributes.label"
                            :is="getInputType"
                            :items="getOptions"
                            :item-text="attributes.itemsText"
                            :item-value="attributes.itemsValue"
                            :item-color="attributes.itemColor"
                            :disabled="!isEditable()"
                            v-model="inputVal"
                            :hint="getPersistentHint"
                            @keyup="onKeyUp()"
                            :rules="attributes.rules"
                            persistent-hint
                            v-bnmask="attributes.mask"
                            :clearable="getClearable"
                            :counter="attributes.counter"
                            :path="attributes.path"
                            :min="attributes.min"
                            :max="attributes.max"
                            :default-date="attributes.defaultDate"
                            :date-hint="attributes.dateHint"
                            @blur="blurFn()"
                            @change="changeFn($event)"
                            :prefix="attributes.prefix"
                            :ref="attributes.mezo"
                            :id="attributes.mezo + '-input'"
                            :error="attributes.error ? attributes.error : false"
                            :error-messages="attributes.errorMessages ? attributes.errorMessages : ''"
                            :attributes="attributes"
                            :afterDatePath="attributes.afterDatePath"
                            :beforeDatePath="attributes.beforeDatePath"
                            :append-icon="attributes.innerIcon"
                            @click:append="($event) => {
                                if (typeof attributes.innerIconClick === 'function'){
                                    attributes.innerIconClick();
                                }
                            }"
                            @click:clear="clearFn"
                            @keydown="keyDownFn($event)"
                            @keypress="keyDownFn($event)"
                            :outlined="cfg.props.outlined"
                            :placeholder="attributes.placeholder"
                            :persistent-placeholder="true"
                            :multiple="attributes.multiple"
                            :true-value="attributes.trueValue"
                            :false-value="attributes.falseValue"
                        >
                            <template
                                v-if="attributes.type === 'checkbox'"
                                #label
                            >
                                <span
                                    :class="attributes.labelClass"
                                    :style="labelStyles"
                                >
                                    {{ attributes.label }}
                                </span>
                            </template>
                            <template v-if="attributes.suffix" #append>
                                <span class="suffix" v-html="attributes.suffix" />
                            </template>
                        </component>
                    </v-flex>
                </v-layout>
            </BnHelpField>
        </v-flex>
    </transition>
</template>
<script>

import storeValueByPath from '../../mixins/StoreValueByPath';
import bnFormField from '../../mixins/bnFormField';

export default {

    inheritAttrs: false,

    mixins: [storeValueByPath, bnFormField],

};
</script>
<style scoped>

.bn-input-label {
    font-size: 17px;
    /*color: rgb(151, 151, 151);*/
}

.flex-class {
    /*margin-top: 10px;*/
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
}

@media only screen and (max-width: 960px) {
    .input-wrapper {
        flex-direction: column;
    }
}

.separate-label {
    height: 56px;
    display: inline-flex;
    align-items: center;
    padding-right: 16px;
}

.suffix {
    margin-top: 3px;
}
</style>
